import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import formatCategoryLabel from "../../../utils/formatCategoryLabel";
import formatCartItemDetails from "../../../utils/formatCartItemDetails";

const OrderItemList = ({ items }) => (
  <Grid container spacing={2}>
    {items.map((item, idx) => {
      const categoryLabel = formatCategoryLabel(item);
      const details = formatCartItemDetails(item);

      return (
        <Grid item xs={12} md={6} key={idx}>
          <Box display="flex" gap={2} alignItems="center">
            <Box
              component="img"
              src={item.image}
              alt={item.displayName || item.name}
              sx={{
                width: 70,
                height: 70,
                borderRadius: 2,
                objectFit: "cover",
              }}
            />
            <Box>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: "16px",
                  color: "primary.main",
                  fontWeight: "bold",
                }}>
                {categoryLabel}
              </Typography>

              <Typography variant="body2" color="text.secondary">
                Qty: {item.quantity} • $
                {typeof item.totalPrice === "number"
                  ? item.totalPrice.toFixed(2)
                  : "0.00"}
              </Typography>

              {details.map(({ label, value }, i) => (
                <Typography
                  key={i}
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontSize: "13px" }}>
                  {label}: {value}
                </Typography>
              ))}
            </Box>
          </Box>
        </Grid>
      );
    })}
  </Grid>
);

export default OrderItemList;
